import { Component, inject } from '@angular/core';
import { ActionResult } from '@ntap/core';
import { ConfirmationService } from 'primeng/api';
import { catchError, flatMap, map, Observable, Subject } from 'rxjs';
import { ItemsListActionComponent } from '../items-list-action/items-list-action.component';

@Component({
  selector: 'app-delete-multiple-documents',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class DeleteMultipleDocumentsComponent extends ItemsListActionComponent {
  private subject$ = new Subject<Observable<ActionResult>>();

  confirmationService = inject(ConfirmationService);

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.listViewProvider.selectedItems$.pipe(
      map((selectedItems) => {
        return (
          selectedItems.length <= 0 ||
          selectedItems.some((item: any) => item['pis~dokument~status'] === 'D')
        );
      })
    );
  }

  protected override doExecute(): Observable<ActionResult> {
    this.confirmationService.confirm({
      message: 'Jeste li sigurni da želite obrisati označene objekte?',
      accept: () => {
        this.subject$.next(super.doExecute());
      }
    });
    return this.subject$.pipe(
      flatMap((p) => p),
      catchError((e) => {
        this.notificationService.error(e.error?.message || e);
        throw e;
      })
    );
  }
}
